<div class="tab-container mat-typography">
  <mifosx-entity-datatable-tab
    entityType="Fixed Deposit Product"
    [entityId]="entityId"
    [multiRowDatatableFlag]="multiRowDatatableFlag"
    [entityDatatable]="entityDatatable"
  >
  </mifosx-entity-datatable-tab>
</div>
